module.exports = __webpack_public_path__ + "media/images/redesign-images/home-new/higher-ed-cc3affc6b2d6fe902e70bc494f253c3a.jpg";